export default __webpack_public_path__ + "static/media/img-0374-ovato-nation-premium-face.b6e646ae.png";